import React from "react";
import {
  FormControl,
  InputLabel,
  makeStyles,
  Theme,
  createStyles,
  Select,
  MenuItem,
  FormHelperText,
} from "@material-ui/core";

/** スタイル定義 */
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  })
);

export interface PlainSelectDef {
  name: string;
  value: string;
}

interface PlainSelectProps {
  id: string;
  label: string;
  data: string;
  defs: PlainSelectDef[];
  error?: boolean;
  helperText?: string;
  handleChange?:
    | ((
        event: React.ChangeEvent<{
          name?: string | undefined;
          value: unknown;
        }>,
        child: React.ReactNode,
        key?: string | number | undefined
      ) => void)
    | undefined;
  className?: any;
  groupId?: string | number | undefined;
  autoFocus?: boolean;
}

/** プレーン選択 */
export function PlainSelect(props: PlainSelectProps) {
  const classes = useStyles();

  const {
    id,
    label,
    data,
    defs,
    error,
    helperText,
    handleChange,
    className,
    groupId,
    autoFocus,
  } = props;

  //--------------------
  // コンポーネント
  return (
    <FormControl
      className={className || classes.formControl}
      size="small"
      error={error}
      style={{
        fontSize: "0.875rem",
      }}
    >
      {label !== "" && <InputLabel id={`${id}_label`}>{label}</InputLabel>}
      <Select
        labelId={`${id}_label`}
        id={`${id}`}
        value={data}
        onChange={(
          event: React.ChangeEvent<{
            name?: string | undefined;
            value: unknown;
          }>,
          child: React.ReactNode
        ) => {
          if (handleChange) {
            handleChange(event, child, groupId);
          }
        }}
        style={{ fontSize: "0.875rem" }}
        error={error}
        autoFocus={autoFocus}
      >
        {defs.map((option: { name: string; value: string }) => {
          const { name, value } = option;
          return (
            <MenuItem value={value} key={value}>
              {name}
            </MenuItem>
          );
        })}
      </Select>
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  );
}
